export var IUser;
(function (IUser) {
    let Type;
    (function (Type) {
        Type["GUEST"] = "GUEST";
        Type["UNKNOWN"] = "UNKNOWN";
        Type["BRAND_USER"] = "BRAND_USER";
        Type["USER"] = "USER";
        Type["STYLIST"] = "STYLIST";
        Type["EDITOR"] = "EDITOR";
        Type["ADMIN"] = "ADMIN";
        Type["CONSUMER"] = "CONSUMER";
        Type["DEVELOPER"] = "DEVELOPER";
        Type["AUDITOR"] = "AUDITOR";
        Type["POTENTIAL_SIGN_UP_LEAD"] = "POTENTIAL_SIGN_UP_LEAD";
        Type["SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
    })(Type = IUser.Type || (IUser.Type = {}));
    /**
     * A user's preference for a certain type of email, such as marketing emails.
     */
    let EmailPreference;
    (function (EmailPreference) {
        /**
         * We should send emails of a certain type to the user.
         */
        EmailPreference["OPTED_IN"] = "OPTED_IN";
        /**
         * We should not send emails of a certain type to the user.
         */
        EmailPreference["OPTED_OUT"] = "OPTED_OUT";
        /**
         * The user has not decided on a preference, we should prompt them at a later time.
         */
        EmailPreference["UNDECIDED"] = "UNDECIDED";
    })(EmailPreference = IUser.EmailPreference || (IUser.EmailPreference = {}));
    /**
     * Return an instance of IUser with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IUser.build = (partial) => (Object.assign({ roles: [], addresses: [], instruments: [], capabilities: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IUser || (IUser = {}));
